module.exports = __webpack_public_path__ + "media/images/lb/873-dbf42cac473c456ea7ff3463679ec35e.svg";